import { Box, Button } from '@material-ui/core';
import GenericModal from 'components/modals/generic/modal';
import React from 'react';
import { useDispatch } from 'react-redux';
import { selectTab, showTabs } from 'redux/home/home.action';
import useStyles from '../../components/modals/generic/modal.styles';

type ModalProps = {
	isOpen: boolean;
	onSubmit(): Promise<void>;
	onClose(): void;
	floorName: string;
};

export const SaveFloorModal = ({ floorName, isOpen, onClose, onSubmit }: ModalProps) => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const onCancel = () => {
		onClose();
	};

	const onSave = () => {
		onSubmit();
		onClose();
		dispatch(showTabs(false));
	};

	const onSaveAndContinue = () => {
		onSubmit();
		onClose();
		dispatch(selectTab(2));
	};
	return (
		<GenericModal
			title="Save Floor"
			content={
				<div>
					are you sure you want to save <span style={{fontWeight: "bold"}}>{floorName}</span> Floor?
				</div>
			}
			footer={
				<Box className={classes.modalFooter}>
					<Button
						variant="outlined"
						color="secondary"
						className={classes.modalButton}
						onClick={onCancel}
					>
						Cancel
					</Button>
					<Button
						variant="contained"
						color="secondary"
						className={classes.modalButton}
						onClick={onSave}
					>
						Save
					</Button>
					<Button
						variant="contained"
						color="secondary"
						className={classes.modalButton}
						onClick={onSaveAndContinue}
					>
						Save & Continue
					</Button>
				</Box>
			}
			onClose={onClose}
			isOpen={isOpen}
		/>
	);
};
